import { fetchJsonRobust } from './fetch'
import type { GooglePlaceData } from '../../types'
import { titleLooksUninteresting } from '../../utils/text'

const FETCH_TIMEOUT_MS = 9000
const FETCH_RETRIES = 2

/**
 * Check if Google Place types look uninteresting
 */
function googleTypeLooksUninteresting(types: string[]): boolean {
  const t = new Set((types || []).map((x) => String(x).toLowerCase()))
  const bad = [
    'gas_station',
    'rest_stop',
    'car_dealer',
    'parking',
    'car_wash',
    'atm',
    'hospital',
    'doctor',
    'pharmacy',
    'dentist',
    'gym',
    'stadium',
    'sports_club',
    'bowling_alley',
    'movie_theater',
    'restaurant',
    'cafe',
    'fast_food_restaurant',
    'lodging',
  ]

  for (const b of bad) {
    if (t.has(b)) return true
  }

  return false
}

/**
 * Fetch Google Places near a location
 */
export async function fetchGooglePlaces(
  lat: number,
  lon: number,
  radius: number
): Promise<GooglePlaceData[]> {
  const minRating = 4.4
  const minRatings = 120
  const url = `/.netlify/functions/places?lat=${encodeURIComponent(lat)}&lon=${encodeURIComponent(lon)}&radius=${encodeURIComponent(radius)}&minRating=${minRating}&minRatings=${minRatings}`

  const data = await fetchJsonRobust(
    url,
    {},
    { timeoutMs: FETCH_TIMEOUT_MS, retries: FETCH_RETRIES }
  )

  const places = data?.places || []
  return places.filter(
    (p: GooglePlaceData) =>
      !titleLooksUninteresting(p.name) &&
      !googleTypeLooksUninteresting(p.types || [])
  )
}
